<template>
    <div class="jf_container">
        <div class="jf_conditionBox kaohe">
            <mySearch
                class="my-search"
                @searchData="searchData"
                :paramData="searchParam"
                searchApi="point_check/index"
                v-model="searchContent"
            ></mySearch>
            <el-date-picker
                class="picker"
                v-model="date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="searchParam.date=date;getCheckList()"
            ></el-date-picker>
            <el-select
                class="topSelect"
                v-model="searchParam.typeid"
                placeholder="请选择分类"
                clearable
                @change="getCheckList()"
            >
                <el-option
                    v-for="item in assortArray"
                    :key="item.id+1000"
                    :label="item.typename"
                    :value="item.id"
                >
                    <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                </el-option>
            </el-select>
            <el-select class="topSelect" v-model="tabIndex" placeholder="审核状态" @change="handleTabIndex(tabIndex*1+1)">
                <el-option
                    v-for="(item, index) in tabData"
                    :key="index+1400"
                    :label="item"
                    :value="index"
                ></el-option>
            </el-select>
            <button class="createBtn" @click="showAddBox=1">新增</button>
        </div>
        <!-- 数据表格 -->
        <el-table class="elTable" :data="tableData">
            <el-table-column prop="username" label="员工姓名" header-align="center"></el-table-column>
            <el-table-column
                prop="typename"
                label="积分分类"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_name"
                label="规则名称"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                prop="rule_des"
                label="积分细则"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column prop="content" label="申请说明" align="center" :show-overflow-tooltip="true"></el-table-column>
            <el-table-column label="奖惩分数" align="center">
                <template slot-scope="scope">
                    <span
                        :style="{'color':scope.row.rule_type==1?'#67C23A':'#F56C6C'}"
                    >{{scope.row.rule_type==1?'+':'-'}}{{scope.row.score}}</span>
                </template>
            </el-table-column>
            <el-table-column label="标准分数" align="center">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.score_type == 1 ? scope.row.score_fixed: scope.row.score_min+' ~ '+scope.row.score_max}}
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="create_name" label="录入人" header-align="center"></el-table-column>
            <el-table-column
                prop="check_time"
                label="申请日期"
                align="center"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
                    label="驳回理由"
                    align="center"
                    :show-overflow-tooltip="true"
                    v-if="tabIndex==2">
                <template slot-scope="scope" >
                    <span v-if="scope.row.reason">{{scope.row.reason}}</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" align="center" v-if="tabIndex===0">
                <template slot-scope="scope">
                    <el-button
                        @click="showDialog(scope.row)"
                        type="text"
                        size="small"
                        style="color:#E6BE8A"
                    >编辑</el-button>
                    <el-button
                        @click="cancel(scope.row.id)"
                        type="text"
                        size="small"
                        style="color:#ff5454"
                    >撤销</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 撤销弹窗 -->
        <el-dialog class="elDialog" :visible.sync="cancelVisible" width="350" :show-close="false">
            <span class="tip">确认要撤销此项积分申请吗？</span>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelVisible = false">取 消</el-button>
                <el-button type="warning" @click="handleVerify">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 新增考核 -->
        <div class="myDialog kaoheAdd" v-if="showAddBox">
            <div class="myDialog_content shenqing-myDialog_content">
                <h4 class="myDialog_h">
                    {{showAddBox==1?'新增考核':'编辑考核'}}
                    <i class="close el-icon-circle-close-outline" @click="resetData()"></i>
                </h4>
                <div class="inp_wrap inline_inp">
                    <label>录入人:</label>
                    <el-input v-model="enter_user" disabled></el-input>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>录入日期:</label>
                    <el-date-picker
                        class="popupPiker"
                        disabled
                        :value="new Date()"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-if="showAddBox==1"
                    ></el-date-picker>
                    <el-date-picker
                        class="popupPiker"
                        disabled
                        v-model="enter_time"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                        v-if="showAddBox==2"
                    ></el-date-picker>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>检查人:</label>
                    <el-select v-model="checkerId" placeholder="请选择">
                        <el-option
                            v-for="item in employeeList"
                            :key="item.user_id"
                            :label="item.username"
                            :value="item.user_id"
                        ></el-option>
                    </el-select>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>申请日期:</label>
                    <el-date-picker
                        v-model="checkDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期"
                    ></el-date-picker>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>员工姓名:</label>
                    <el-select v-model="employeeInfo" placeholder="请选择" value-key="user_id">
                        <el-option
                            v-for="item in employeeList"
                            :key="item.user_id"
                            :label="item.username"
                            :value="item"
                        ></el-option>
                    </el-select>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>岗位:</label>
                    <el-input disabled v-model="employeeInfo.gangwei"></el-input>
                </div>
                <!-- <div class="inp_wrap inline_inp">
                    <label>积分分类:</label>
                    <el-select
                        v-model="parentAssortId"
                        placeholder="请选择分类"
                        @change="choosechildAssortArr"
                    >
                        <el-option
                            v-for="item in assortArray"
                            :key="item.id+1000"
                            :label="item.typename"
                            :value="item.id"
                            :disabled="item.pid==0"
                        >
                            <span :class="{'secondary': item.pid!==0}">{{item.typename}}</span>
                        </el-option>
                    </el-select>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>规则名称:</label>
                    <el-select
                        v-model="childAssortId"
                        placeholder="请选择分类"
                        @change="handleChangeRule"
                    >
                        <el-option
                            v-for="item in childAssortArr"
                            :key="item.id+1200"
                            :label="item.rule_name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </div> -->
                <div class="inp_wrap">
                    <label>规则名称:</label>
                    <el-autocomplete
                        style="width:200px!important"
                        v-model="childAssortName"
                        :fetch-suggestions="querySearchAsync"
                        placeholder="请输入规则名称"
                        @select="handleChangeRule"
                    ></el-autocomplete>
                </div>
                <div class="inp_wrap">
                    <label>积分细则:</label>
                    <div class="xizeBox" style="padding:6px" v-text="rule_des"></div>
                </div>
                <div class="inp_wrap">
                    <label style="vertical-align: top;">申请说明:</label>
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder="请输入内容"
                        resize="none"
                        v-model="content"
                    ></el-input>
                </div>
                <div class="inp_wrap inline_inp">
                    <label>分数:</label>
                    <el-input
                        type="number"
                        v-model="applyScore"
                        :disabled="score_type==1?true:false"
                    ></el-input>
                </div>
                <div class="btnWrap">
                    <button class="assort_confim-btn" @click="resetData()">返回</button>
                    <button class="assort_confim-btn confim" @click="addApply">提交</button>
                </div>
            </div>
        </div>
        <!-- 页码 -->
        <p
            class="pageTotal"
        >共有 {{pageData.count}} 条记录 当前 {{pageData.page}} 页/共 {{pageData.pagetotal}} 页</p>
        <el-pagination
            class="pageBody"
            @current-change="getCheckList(1)"
            :current-page.sync="pageData.page"
            background
            layout="prev, pager, next"
            :total="pageData.count*1"
        ></el-pagination>
    </div>
</template>
<script>
import mySearch from "../../components/mySearch.vue";
var baseUrl = process.env.apiUrl + "point/";
export default {
    data() {
        return {
            activeId: "",
            cancelVisible: false,
            tabData: ["未审核", "已通过", "未通过"],
            tabIndex: 0,
            date: null,
            tableData: [],
            token: "",
            assortArray: [],
            childAssortArr: [],
            parentAssortId: "",
            childAssortId: "",
            applyScore: "",
            rule_type: "",
            rule_des: "",
            score_type: "",
            score_max: "",
            score_min: "",
            employeeList: [],
            checkerId: "",
            employeeInfo: {},
            checkDate: "",
            content: "",
            enter_user: "", // 录入人
            pageData: {
                count: "", // 总条数
                page: 1, // 当前页
                pagetotal: "" // 总页数
            }, // 页数
            showAddBox: 0, // 显示新增弹窗
            activeRuleId: "",
            enter_time: '',
            searchParam: {
                from: 1,
                date: "",
                shenhe: 1,
                typeid: ''
            },
            searchContent: "",
            childAssortName: ''
        };
    },
    created() {
        this.token = this.$cookies.get("token");
        this.getCheckList();
        this.getAssortList();
        this.getEmployee();

    },
    components: {
        mySearch
    },
    methods: {
        // 获取员工列表
        async getEmployee() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/get_user_info",
                    {
                        token: that.token
                    }
                );
                if (res.status == 1) {
                    that.employeeList = res.allusers;
                    that.enter_user = res.username;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取分类列表
        async getAssortList() {
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_type/index", {
                    token: that.token
                });
                if (res.status == 1) {
                    if (res.data && res.data.length > 0) {
                        that.assortArray = [];
                        res.data.forEach((element, index) => {
                            that.assortArray.push({
                                typename: element.typename,
                                pid: element.pid,
                                id: element.id
                            });
                            if (element.child && element.child.length > 0) {
                                element.child.forEach((ele, i) => {
                                    that.assortArray.push({
                                        typename: ele.typename,
                                        pid: ele.pid,
                                        id: ele.id
                                    });
                                });
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 获取规则列表
        async choosechildAssortArr(type) {
            if (type != "edit") {
                // 点击编辑时传入 edit
                this.childAssortId = "";
                this.rule_des = "";
                this.applyScore = "";
            }
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_rule/index", {
                    token: that.token,
                    typeid: that.parentAssortId
                });
                if (res.status == 1) {
                    that.childAssortArr = res.data;
                    if (type == "edit") {
                        // 编辑时 获取分数类型和范围
                        res.data.forEach(ele => {
                            if (that.childAssortId == ele.id) {
                                that.score_type = ele.score_type;
                                if (ele.score_type == 2) {
                                    that.score_max = ele.score_max;
                                    that.score_min = ele.score_min;
                                } else {
                                    that.applyScore = ele.score;
                                }
                            }
                        });
                    }
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 选择规则后触发
        // handleChangeRule() {
        //     this.applyScore = "";
        //     this.childAssortArr.forEach(ele => {
        //         if (ele.id == this.childAssortId) {
        //             this.rule_des = ele.rule_des;
        //             this.rule_type = ele.rule_type;
        //             this.score_type = ele.score_type;
        //             if (ele.score_type == 2) {
        //                 this.score_max = ele.score_max;
        //                 this.score_min = ele.score_min;
        //             } else {
        //                 this.applyScore = ele.score;
        //             }
        //             return;
        //         }
        //     });
        // },
        // 新增
        async addApply() {
            if (this.checkerId == "") {
                this.$message.error("请选择检查人");
                return;
            }
            if (this.checkDate == "") {
                this.$message.error("请选择申请日期");
                return;
            }
            if (this.employeeInfo && this.employeeInfo.user_id == "") {
                this.$message.error("请选择员工姓名");
                return;
            }
            // if (this.parentAssortId == "") {
            //     this.$message.error("请选择分类");
            //     return;
            // }
            if (this.childAssortId == "") {
                this.$message.error("请从实时搜索结果中选择规则名称");
                return;
            }
            if (
                this.score_type == 2 &&
                (this.applyScore < this.score_min*1 ||
                    this.applyScore > this.score_max*1)
            ) {
                this.$message.error("申请分数超出范围");
                return;
            }
            let that = this;
            let url =
                this.showAddBox == 1 ? "point_check/add" : "point_check/update";
            try {
                let res = await that.$http.post(baseUrl + url, {
                    token: that.token,
                    from: 1, // 1 考核列表  2.个人申请列表
                    check_time: that.checkDate,
                    rule_id: that.childAssortId,
                    score: that.applyScore,
                    content: that.content,
                    rule_type: that.rule_type,
                    id: that.showAddBox == 2 ? that.activeRuleId : null,
                    check_user: that.checkerId,
                    user_id: that.employeeInfo.user_id,
                    user_gangwei: that.employeeInfo.gangwei
                });
                if (res.status == 1) {
                    that.$message.success(res.msg);
                    that.getCheckList();
                    that.resetData();
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 考核列表
        async getCheckList(type) {
            if (type !== 1) {
                this.pageData.page = 1
            }
            let that = this;
            try {
                let res = await that.$http.post(baseUrl + "point_check/index", {
                    token: that.token,
                    from: 1, //  1 考核列表  2.个人申请列表 3.审核列表
                    shenhe: that.tabIndex + 1, // 1.未审核 2.审核通过  3.审核驳回
                    time_s:
                        that.date && that.date.length > 0 ? that.date[0] : "",
                    time_e:
                        that.date && that.date.length > 0 ? that.date[1] : "",
                    search: that.searchContent,
                    page: that.pageData.page,
                    typeid: that.searchParam.typeid
                });
                if (res.status === 1) {
                    that.tableData = res.data;
                    that.pageData.count = res.map.count;
                    that.pageData.page = res.map.page*1;
                    that.pageData.pagetotal = res.map.pagetotal;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        // 编辑
        showDialog(item) {
            this.childAssortName = item.rule_name
            this.showAddBox = 2;
            this.activeRuleId = item.id;
            this.checkDate = item.check_time;
            this.childAssortId = item.rule_id;
            this.applyScore = item.score;
            this.content = item.content;
            this.rule_type = item.rule_type;
            this.checkerId = item.check_user*1;
            this.rule_des = item.rule_des;
            this.parentAssortId = item.type_id;
            this.employeeInfo = {
                user_id: item.user_id*1,
                username: item.username,
                gangwei: item.user_gangwei
            }
            this.enter_time = item.create_time
            this.choosechildAssortArr("edit");
        },
        // 关闭弹窗时 重置数据
        resetData() {
            this.childAssortName = ''
            this.showAddBox = 0
            this.activeRuleId = ''
            this.checkDate = ''
            this.childAssortId = ''
            this.applyScore = ''
            this.content = ''
            this.rule_type = ''
            this.checkerId = ''
            this.rule_des = ''
            this.parentAssortId = ''
            this.employeeInfo = {
                user_id: '',
                username: '',
                gangwei: ''
            }
            this.enter_time = ''
        },
        // 撤销弹窗按钮
        cancel(id) {
            this.cancelVisible = true;
            this.activeId = id;
        },
        // 撤销 请求函数
        async handleVerify() {
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_check/delete",
                    {
                        id: that.activeId
                    }
                );
                if (res.status == 1) {
                    that.$message.success("撤销成功");
                    that.getCheckList();
                    that.cancelVisible = false;
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        },
        searchData(data) {
            this.tableData = data.data;
            this.pageData.count = data.map.count;
            this.pageData.page = data.map.page*1;
            this.pageData.pagetotal = data.map.pagetotal;
        },
        // 切换 tab
        handleTabIndex(i) {
            this.searchParam.shenhe = i;
            this.date = ''
            this.searchContent = ''
            this.searchParam.typeid = ''
            this.getCheckList();
        },
        // 选择规则后触发
        handleChangeRule(item) {
            this.childAssortId = item.id
            this.applyScore = "";
            this.rule_des = item.rule_des;
            this.rule_type = item.rule_type;
            this.score_type = item.score_type;
            if (item.score_type == 2) {
                this.score_max = item.score_max;
                this.score_min = item.score_min;
            } else {
                this.applyScore = item.score;
            }
        },
        // 实时搜索 规则名称函数
        async querySearchAsync(queryString, cb) {
            this.childAssortId = ''
            let that = this;
            try {
                let res = await that.$http.post(
                    baseUrl + "point_rule/search",
                    {
                        search: queryString
                    }
                );
                if (res.status == 1) {
                    let ret = []
                    if (res.data.length>0){
                        res.data.forEach(item => {
                            let obj = {}
                            obj = {...item}
                            obj.value = item.rule_name
                            ret.push(obj)
                        })
                    } else {
                        ret = [{'value': '暂无数据'}]
                    }
                    cb(ret);
                } else {
                    that.$message.error(res.msg);
                }
            } catch (err) {
                that.$message.error(err);
            }
        }
    }
};
</script>
<style scoped>
.jf_container {
    min-width: 1040px;
}
.jf_conditionBox {
    width: 100%;
    height: 60px;
    padding-top: 10px;
    padding-left: 30px;
    background: #f5f5f5;
}
.elTable {
    width: 96%;
    margin: 20px 0 0 30px;
    text-align: center;
}
.assort,
.my-search,
.topSelect {
    float: left;
}
.picker {
    float: left;
    margin-left: 20px;
}
.dialogText {
    border-radius: 4px;
    width: 280px;
    height: 90px;
    padding: 6px;
    outline: none;
    resize: none;
}
.shenqing-myDialog_content {
    width: 560px;
}
.createBtn {
    float: right;
    margin-right: 20px;
    outline: none;
    border: none;
    border-radius: 4px;
    width: 114px;
    height: 40px;
    font-size: 16px;
    text-align: center;
    color: #fff;
    background: #E6BE8A;
}
.close {
    float: right;
    margin: 8px 20px;
}
.btnWrap {
    text-align: center;
}
.btnWrap .assort_confim-btn {
    display: inline-block;
    margin: 30px 20px 0;
}
.confim {
    color: #fff;
    background: #E6BE8A;
}
.inline_inp {
    display: inline-block;
}
.inp_wrap label {
    font-size: 15px;
}
.xizeBox {
    display: inline-block;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    width: 416px;
    min-height: 40px;
    vertical-align: middle;
}
#upload {
    position: absolute;
    bottom: 0;
    right: 0;
    opacity: 0;
    width: 0;
    height: 0;
}
.uploadBtn {
    border-radius: 4px;
    width: 150px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #a3a3a6;
    background: #f1f1f1;
    cursor: pointer;
}
.fileName {
    display: inline-block;
    margin-left: 30px;
    height: 40px;
}
.el-icon-check {
    margin-left: 20px;
    font-size: 16px;
    font-weight: 600;
    color: green;
}
.topSelect {
    margin-left: 20px;
}
.xizeBox {
    display: inline-block;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    width: 416px;
    min-height: 40px;
    vertical-align: middle;
    font-size: 14px;
}
.secondary {
    margin-left: 30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/jifen/kaohe.vue